import { AuthError, updateMFAPreference } from "aws-amplify/auth";

import { UseMutationOptions, useMutation } from "@tanstack/react-query";

export type MfaType = "sms" | "totp" | "email";
const updatePreferredMfa = async ({
  type,
}: {
  type: MfaType;
}): Promise<void> => {
  await updateMFAPreference({ [type]: "PREFERRED" });
};

const unPreferredMfa = async ({ type }: { type: MfaType }): Promise<void> => {
  await updateMFAPreference({ [type]: "NOT_PREFERRED" });
};

const disableMfa = async ({ type }: { type: MfaType }): Promise<void> => {
  await updateMFAPreference({ [type]: "DISABLED" });
};

function useUpdatePreferredMfa(
  mutationOptions?: UseMutationOptions<void, AuthError, { type: MfaType }>,
) {
  return useMutation({
    mutationFn: updatePreferredMfa,
    ...mutationOptions,
  });
}

function useUnPreferredMfa(
  mutationOptions?: UseMutationOptions<void, AuthError, { type: MfaType }>,
) {
  return useMutation({
    mutationFn: unPreferredMfa,
    ...mutationOptions,
  });
}

function useDisableMfa(
  mutationOptions?: UseMutationOptions<void, AuthError, { type: MfaType }>,
) {
  return useMutation({
    mutationFn: disableMfa,
    ...mutationOptions,
  });
}
export { useDisableMfa, useUnPreferredMfa, useUpdatePreferredMfa };
